

















import {Component, Emit, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class StockToggleButtonField extends Vue {
  // props
  @Prop({})
  value!: string;
  @Prop({})
  trueValue!: string;
  @Prop({})
  falseValue!: string;
  @Prop({})
  trueButtonLabel!: string;
  @Prop({})
  falseButtonLabel!: string;
  @Prop({})
  disabled!: boolean;

  // computed
  get styleVariables() {
    return {
      '--true-button-label': `"${this.trueButtonLabel}"`,
      '--false-button-label': `"${this.falseButtonLabel}"`,
    };
  }

  // events
  @Emit('input')
  input(event: any): string {
    if (event.target.checked) {
      return this.trueValue;
    }
    return this.falseValue;
  }

  @Emit('click')
  private doClick(): void {
      return;
  }

  @Emit('change')
  private change(event: Event): Event {
    return event;
  }


  // lifecycle hook
  // nothing
}
